import { useCallback, useState } from "react";

const GALLERY_DARK_MODE_KEY = "galleryDarkMode";

const useGalleryDarkMode = () => {
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem(GALLERY_DARK_MODE_KEY) === "true",
  );
  const toggleDarkMode = useCallback(() => {
    setDarkMode(prev => {
      const next = !prev;
      localStorage.setItem(GALLERY_DARK_MODE_KEY, String(next));
      return next;
    });
  }, []);
  return [darkMode, toggleDarkMode];
};

export default useGalleryDarkMode;
